import { useEffect } from 'react';
import {
  Box,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId5 = ['no26', 'no27', 'no28', 'no29', 'no30'];

const 영역5 = [
  {
    id: 1,
    ko: '26. 말초정맥관 삽입',
    info: ['간호사가 시행한 경우 해당'],
    desc: ['해당 없음', '1점'],
  },
  {
    id: 2,
    ko: '27. 튜브삽입 또는 관리',
    info: [
      'L-tube, Pextal tube, 흉관 삽입 당일과 그 이후 관리 혹은 유지도 포함됨',
    ],
    desc: [
      '해당 없음',
      '2점 : L-tube 삽입 및 관리',
      '2점 : Rectal tube 삽입 및 관리',
      '2점 : Foley bag 삽입 당일',
      '2점 : 중심정맥관 삽입 당일',
      '3점 : 흉관 삽입 및 관리',
    ],
  },
  {
    id: 3,
    ko: '28. 수술 및 시술 당일 전 처치',
    info: [
      '수술 또는 시술 당일의 동의서, 금식 확인, 피부 준비, 투약 및 교육 설명 등 포함',
    ],
    desc: ['해당 없음 ', '3점'],
  },
  {
    id: 4,
    ko: '29. 심폐소생술',
    info: ['CPR 시행 시 '],
    desc: ['해당 없음  ', '6점'],
  },
  {
    id: 5,
    ko: '30. 기타 15분 이상 소요되는 처치',
    info: ['간호사가 직접 시행한 경우'],
    desc: ['해당 없음  ', '2점'],
  },
];

const radioId6 = ['no31'];

const 영역6 = [
  {
    id: 1,
    ko: '31. 신환 입원',
    info: [
      '입원 당시 병력청취, V/S check, 신체계측, 각종 행정업무 및 교육 등 포함',
    ],
    desc: ['해당 없음', '5점'],
  },
];

const radioId7 = ['no32', 'no33', 'no34'];

const 영역7 = [
  {
    id: 1,
    ko: '32. 교육 15분 이상',
    info: ['질환별 환자 교육(당뇨, 고혈압, 심장질환 등)', '집단 교육은 제외'],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 2,
    ko: '33. 환자, 가족의 정서적 지지 15분 이상',
    info: ['환자 또는 가족에게 정서적 지지를 15분 이상 제공한 경우'],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 3,
    ko: '34. 의사소통',
    info: [
      '정신지체, 시각/청각/언어력 소실이 있는 환자와 의사소통 할 때 보통의 환자보다 많은 시간과 노력이 요구되는 경우 해당',
    ],
    desc: ['해당 없음 ', '3점'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum9: number;
  setSum9: (sum9: number) => void;

  sum10: number;
  setSum10: (sum10: number) => void;

  sum11: number;
  setSum11: (sum11: number) => void;
}

const KPCSGWContents5 = (props: Props) => {
  const {
    disabled,
    setValue,
    getValues,
    setSum9,
    setSum10,
    setSum11,
    register,
  } = props;

  const calculateSumValue5 = () => {
    setSum9(
      radioId5.reduce((acc, cur) => {
        if (cur === 'no27' && Number(getValues(cur)) > 0) {
          if (Number(getValues(cur)) < 5) {
            const value = 2;
            return value ? acc + value : acc;
          }
          const value = 3;
          return value ? acc + value : acc;
        } else if (cur === 'no28') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        } else if (cur === 'no29') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        } else if (cur === 'no30') {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        }

        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange5 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue5();
  };

  const calculateSumValue6 = () => {
    setSum10(
      radioId6.reduce((acc, cur) => {
        const value = Number(getValues(cur)) * 5;
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange6 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue6();
  };

  const calculateSumValue7 = () => {
    setSum11(
      radioId7.reduce((acc, cur) => {
        if (cur === 'no34') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur)) * 2;
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange7 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue7();
  };

  useEffect(() => {
    calculateSumValue5();
    calculateSumValue6();
    calculateSumValue7();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 처치" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역5.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      borderBottom: 영역5.length - 1 === i ? 'none' : '',
                      verticalAlign: 'top',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역5.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId5[content.id - 1]}
                      defaultValue={Number(getValues(radioId5[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId5[content.id - 1]}
                                value={i}
                                onChange={handleChange5}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역5.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => (
                        <TableRow
                          sx={{
                            lineHeight: '42px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}>{v}</Box>
                        </TableRow>
                      ))}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 입원관리" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '30px' }}>
          <TableBody>
            {영역6.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 'none',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 'none',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId6[content.id - 1]}
                      defaultValue={Number(getValues(radioId6[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId6[content.id - 1]}
                                value={i}
                                onChange={handleChange6}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 'none',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 정서적 지지 및 상담/교육" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '30px' }}>
          <TableBody>
            {영역7.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역7.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역7.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId7[content.id - 1]}
                      defaultValue={Number(getValues(radioId7[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId7[content.id - 1]}
                                value={i}
                                onChange={handleChange7}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역7.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSGWContents5;
